import { Reveal } from "./Reveal";
import { WaitlistForm } from "./WaitlistForm";
import { Logo } from "./Navbar";

export const FinalCta = () => (
  <section id="signup" data-testid="signup-section" className="py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-card p-10 lg:p-16">
          <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-pink/15 blur-3xl" />
          <p className="eyebrow mb-4">Early access</p>
          <h2 className="max-w-2xl font-display text-3xl font-extrabold tracking-tight sm:text-5xl">
            Stop writing notes. <span className="text-cyan">Start listening.</span>
          </h2>
          <p className="mt-4 max-w-xl text-base text-muted-foreground md:text-lg">Join the list and get 5 free recordings when Tilla' launches.</p>
          <div className="mt-10"><WaitlistForm source="final" id="final" /></div>
        </div>
      </Reveal>
    </div>
  </section>
);

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-white/5 py-10">
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 px-6 md:flex-row md:items-center lg:px-10">
      <Logo />
      <p className="font-mono text-xs text-muted-foreground">© {new Date().getFullYear()} Tilla' voice notes</p>
    </div>
  </footer>
);
